import React from 'react';

interface ContentSectionProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  padded?: boolean;
}

export default function ContentSection({ children, style, padded = false }: ContentSectionProps) {
  return (
    <div style={{ ...styles.container, ...(padded ? styles.padded : {}), ...style }}>
      {children}
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
    boxSizing: 'border-box' as const,
  } as React.CSSProperties,

  padded: {
    padding: '0 24px',
  } as React.CSSProperties,
};
